import type {
  EfaxPatient,
  EfaxProvider,
  EfaxProviderFacility,
  EfaxQueueItem,
} from '../types';

export const getProviderDisplayName = (provider: EfaxProvider): string =>
  provider.displayName?.trim() ||
  [provider.firstName, provider.lastName].filter(Boolean).join(' ').trim();

export const getProviderNames = (providers: EfaxProvider[]): string[] =>
  providers.map(getProviderDisplayName).filter(Boolean);

export const getProviderFacility = (
  providers: EfaxProvider[],
): EfaxProviderFacility => {
  const withFacility = providers.find((provider) => provider.facilityName);

  return {
    name: withFacility?.facilityName ?? '',
    type: withFacility?.providerFacilityType ?? '',
  };
};

export const getPatientDisplayName = (patient: EfaxPatient | null): string => {
  if (!patient) return '';

  return (
    patient.displayName?.trim() ||
    [patient.firstName, patient.lastName].filter(Boolean).join(' ').trim()
  );
};

export const getPatientKey = (item: EfaxQueueItem): string =>
  item.patient?.referenceId ?? item.patient?.patientKey ?? '';

export const getRecipientProviders = (item: EfaxQueueItem): string[] =>
  getProviderNames(item.receivingProviders);

export const getRecipientFacility = (
  item: EfaxQueueItem,
): EfaxProviderFacility => getProviderFacility(item.receivingProviders);
